import React from "react";
import * as styles from "@styles/DocumentSelection.css";
import type { DocumentSelectionViewProps } from "@ps-bridge/contracts/documentSelection";
import { ok } from "@ps-bridge/ok";
import * as IO from "@ps-bridge/interop/io";

type DocumentEmptyStateViewProps = Pick<
  DocumentSelectionViewProps,
  "onCreateDocument"
>;

const DocumentEmptyStateView: React.FC<DocumentEmptyStateViewProps> = ({
  onCreateDocument,
}) => (
  <div className={styles.emptyState}>
    <p className={styles.emptyTitle}>No documents yet.</p>
    <p className={styles.emptySubtitle}>
      Create your first document to get started.
    </p>
    <button
      className={styles.emptyCreateButton}
      onClick={() => IO.run(onCreateDocument(ok))}
    >
      Create Document +
    </button>
  </div>
);

export default DocumentEmptyStateView;
